import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { getIconCSSClass } from "../../utils/index";

export default function DocumentLinkMobile({
  id,
  title,
  setModalIsOpen,
  modalIsOpen,
  getDocumentFileName,
  createNonInternalStream,
  linkDocument,
  children,
}) {
  const linkRef = useRef(null);
  const toggle = () => setModalIsOpen(!modalIsOpen);
  const linkName =
    getDocumentFileName &&
    getDocumentFileName.match(/[^\/\\]*?\.[a-z0-9]+?$/i)[0];
  return (
    <>
      <a
        id={`action-point-${id}`}
        title={title}
        download
        target="_blank"
        href={`${process.env.NEXT_PUBLIC_ROOT_URL}/download/${linkDocument}`}
        onClick={() => {
          toggle();
          createNonInternalStream();
        }}
        // tabindex={tabindex}
      >
        {children}
      </a>
    </>
  );
}
